import { Box, Container, makeStyles } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Page from 'src/app/components/Page';

import { Typography } from 'antd';
import LoadingComponent from 'src/app/components/Loading';
import { GetUserInfo } from 'src/features/authSlice';
import Result from './Result';

const VideoPlaybackList = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const isLoading = useSelector(state => state.vodSlice.isLoading);

  useEffect(() => {
    dispatch(GetUserInfo());
  }, [dispatch]);

  return (
      <Page className={classes.root}>
        <Container maxWidth={true} >
          <React.Fragment>
            <Typography
              style={{
                width: '100%',
                height: '36px',
                color: '#0C1132',
                display: 'flex',
                alignItems: 'center',
                fontWeight: 'bold',
                marginTop: '16px',
                fontSize: '20px'
              }}
            >
              Danh sách video phương tiện
            </Typography>
            <Box mt={3}>
              <React.Fragment>
                {isLoading ? (
                  <LoadingComponent />
                ) : (
                  <Result />
                )}
              </React.Fragment>
            </Box>
          
          </React.Fragment>
        </Container>
      </Page>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100vh',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
    paddingLeft: theme.spacing(2)
  },
}));

export default VideoPlaybackList;
